/**
 * Author：brand
 * Creation Time：2019-06-10 11:06
 * Email：brandhuang@qq.com
 */
import ax from '../../axios'

export function getRoleListAPI (params) {
  return ax({
    url: '/wlapi/csmanage/roleList',
    method: 'POST',
    params,
  })
}
export function addRoleDataAPI (params) {
  return ax({
    url: '/wlapi/csmanage/addRoleList',
    method: 'POST',
    params,
  })
}
export function addRoleAPI (params) {
  return ax({
    url: '/wlapi/csmanage/addRole',
    method: 'POST',
    data:params,
  })
}

export function editRoleDataAPI (params) {
  return ax({
    url: '/wlapi/csmanage/editRoleList',
    method: 'POST',
    params,
  })
}
export function eidtRoleAPI (params) {
  return ax({
    url: '/wlapi/csmanage/editRole',
    method: 'POST',
    data:params,
  })
}

export function delRoleSingleAPI (params) {
  return ax({
    url: '/wlapi/csmanage/delRole',
    method: 'POST',
    params,
  })
}

export function delRoleAllAPI (params) {
  return ax({
    url: '/wlapi/csmanage/batchDelRole',
    method: 'POST',
    data:params,
  })
}
